<div class="container p-5">
    <div class="row new-comers-content become-box-content justify-content-center">
            <div class="col-12 text-center">
                <h3>Foire aux questions</h3>
                <!-- <h4 class="dash"></h4> -->
            </div>
        </div>
    <div class="row justify-content-center">
        <!-- <div class="col-lg-6 col-md-12">
            <div class="faq-video">
                <lightgallery [settings]="settings" [onBeforeSlide]="onBeforeSlide">
                    <a
                        data-lg-size="1280-720"
                        data-src="https://www.youtube.com/watch?v=68mTG-fxzX4"
                        data-sub-html="<p>Ednuv Video</p>"
                    >
                        <img src="assets/img/business-coaching/faq.jpg" alt="image">
                        <div class="video-btn">
                            <i class='bx bx-play'></i>
                        </div>
                    </a>
                </lightgallery>
            </div>
        </div> -->
        <div class="col-10">
            <div class="faq-accordion faq-accordion-style-two">
                <accordion>
                    <accordion-group heading="Est-ce que le CACE est une école ? " [isOpened]="false">
                        <p>Non, le CACE n’est pas une école. Nous sommes un trait d’union entre les acteurs du système éducatif et en tent que tel, nous en accompagnons tous les acteurs. (Apprenants, écoles, enseignants, parents, état, etc.)</p>
                    </accordion-group>
                    <accordion-group heading="Depuis quand le CACE existe ?">
                        <!-- <p>Associate: a two-year program that either leads to a specific vocation or transitions to a bachelor program. Bachelor: a four or five-year program where students earn credits in a wide variety of courses.</p> -->
                    </accordion-group>
                    <accordion-group heading="Le CACE dispose t-il d’un internat ?">
                        <!-- <p>Associate: a two-year program that either leads to a specific vocation or transitions to a bachelor program. Bachelor: a four or five-year program where students earn credits in a wide variety of courses.</p> -->
                    </accordion-group>
                    <accordion-group heading="Lorem ipsum dolor sit amet, consectetur adipiscing?">
                        <!-- <p>Associate: a two-year program that either leads to a specific vocation or transitions to a bachelor program. Bachelor: a four or five-year program where students earn credits in a wide variety of courses.</p> -->
                    </accordion-group>
                </accordion>
            </div>
        </div>
    </div>
</div>